Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var reactHookForm = require('react-hook-form');
var reactFeather = require('react-feather');
var core = require('@material-ui/core');
var BaseModal = require('@ds-developer/modal');
var Button = require('@ds-developer/button');
var Yup = require('yup');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var BaseModal__default = /*#__PURE__*/_interopDefaultLegacy(BaseModal);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var RejectLearnerModal = function RejectLearnerModal(_a) {
  var _b;
  var _c;
  var errors = _a.errors,
    handleCancel = _a.handleCancel,
    handleSubmit = _a.handleSubmit,
    handleReasonInputClick = _a.handleReasonInputClick,
    _d = _a.isLoading,
    isLoading = _d === void 0 ? false : _d,
    _e = _a.isValid,
    isValid = _e === void 0 ? false : _e,
    register = _a.register,
    submitting = _a.submitting;
  var actions = React__default['default'].createElement(React.Fragment, null, React__default['default'].createElement(Button__default['default'], {
    "data-test": "reject-learner-modal-cancel-button",
    onClick: handleCancel,
    variant: "outlined",
    disabled: submitting
  }, "Cancel"), React__default['default'].createElement(Button__default['default'], {
    "data-test": "reject-learner-modal-confirm-button",
    onClick: handleSubmit,
    variant: "contained",
    color: "error",
    startIcon: React__default['default'].createElement(reactFeather.Trash2, {
      size: 14
    }),
    loading: isLoading,
    disabled: !isValid || submitting
  }, "Confirm rejection"));
  return React__default['default'].createElement(BaseModal__default['default'], {
    actions: actions,
    open: true,
    title: "Please let us know why you are rejecting this pupil"
  }, React__default['default'].createElement(core.TextField, {
    multiline: true,
    rows: 4,
    placeholder: "Let us know why you want to reject this pupil",
    error: Boolean(errors === null || errors === void 0 ? void 0 : errors.reason),
    fullWidth: true,
    helperText: (_c = errors === null || errors === void 0 ? void 0 : errors.reason) === null || _c === void 0 ? void 0 : _c.message,
    label: "Reason for rejection request",
    name: "reason",
    inputRef: register,
    variant: "outlined",
    type: "text",
    "data-test": "reject-learner-modal-rejection-reason-input",
    FormHelperTextProps: (_b = {},
    // @ts-ignore
    _b["data-test"] = "reject-learner-modal-rejection-reason-helper-text", _b),
    onClick: handleReasonInputClick
  }), React__default['default'].createElement(core.Box, {
    paddingTop: 2
  }, React__default['default'].createElement(core.Typography, null, "You will be charged a rejection fee if you choose to proceed.")));
};
var validationSchema = Yup.object().shape({
  reason: Yup.string().matches(/^\s*\S+(?:\s+\S+){4,}\s*$/, "Please enter at least 5 words").required("Please enter a reason")
});
var RejectLearnerModalStateProvider = function RejectLearnerModalStateProvider(_a) {
  var initialFormFields = _a.initialFormFields,
    submitting = _a.submitting,
    loading = _a.loading,
    submit = _a.submit,
    handleReasonInputClick = _a.handleReasonInputClick,
    handleCancelEvent = _a.handleCancelEvent;
  var _b = reactHookForm.useForm({
      mode: "onChange",
      defaultValues: initialFormFields,
      validationSchema: validationSchema
    }),
    errors = _b.errors,
    isValid = _b.formState.isValid,
    handleSubmit = _b.handleSubmit,
    register = _b.register;
  return React__default['default'].createElement(RejectLearnerModal, {
    errors: errors,
    handleSubmit: handleSubmit(submit),
    handleCancel: handleCancelEvent,
    isValid: isValid,
    isLoading: loading,
    register: register,
    handleReasonInputClick: handleReasonInputClick,
    submitting: submitting
  });
};
exports.default = RejectLearnerModalStateProvider;